module.exports = __webpack_public_path__ + "img/pharmacy.d0e3da06.png";